import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchPaymentAccounts } from '../api';

export const usePaymentAccounts = () => {
  const { data } = useSuspenseQuery({
    queryKey: ['fetchPaymentAccounts'],
    queryFn: () => {
      return fetchPaymentAccounts().then(
        ({ paymentAccounts }) => paymentAccounts
      );
    },
  });

  return data;
};
